/** A size range is two separate choices: how the pattern is proportioned up and down (its length),
 *  and whether it's cut curvy (more seat for the same waist). Stores print them together. */
export const LENGTHS = ["Regular", "Petite", "Short", "Tall"];

/** "Petite" + curvy -> "Petite Curvy"; a curvy in the regular length is just "Curvy". */
export function fitName(length: string | null, curvy: boolean): string | null {
  if (!curvy) return length;
  return !length || length === "Regular" ? "Curvy" : `${length} Curvy`;
}
